import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { clearDataCache } from "../lib/dataCache";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("rp_token");
    if (!t) { setLoading(false); return; }
    // Optimistically restore cached user so the app is usable offline.
    const cached = localStorage.getItem("rp_user");
    if (cached) { try { setUser(JSON.parse(cached)); } catch (e) { /* noop */ } }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("rp_user", JSON.stringify(r.data)); })
      .catch((err) => {
        // Only log out on a real auth rejection; keep session on network/offline errors.
        if (err?.response?.status === 401) {
          localStorage.removeItem("rp_token");
          localStorage.removeItem("rp_user");
          setUser(null);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (identifier, password) => {
    const r = await api.post("/auth/login", { identifier, password });
    clearDataCache();
    localStorage.setItem("rp_token", r.data.token);
    localStorage.setItem("rp_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    clearDataCache();
    localStorage.removeItem("rp_token");
    localStorage.removeItem("rp_user");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, login, logout, loading }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
